import { territoriesConstants } from '../constants/territories';

export function territories(state = {}, action) {
    switch (action.type) {
        case territoriesConstants.GET_ROLLING_MONTHS_REVENUE_REQUEST:
            return {
                ...state,
                monthsLoading: true,
                months: undefined,
                monthTimeseries: undefined,
                monthPie: undefined

            };
        case territoriesConstants.GET_ROLLING_MONTHS_REVENUE_SUCCESS:
            return {
                ...state,
                monthsLoading: false,
                months: action.months,
                monthTimeseries: action.monthTimeseries,
                monthPie: action.monthPie
                
            };
        case territoriesConstants.GET_ROLLING_MONTHS_REVENUE_FAILURE:
            return {
                ...state,
                monthsLoading: false,
                error: action.error
            };
    
        case territoriesConstants.GET_TERRITORIES_REQUEST:
            return {
                ...state,
                loading: true,
                metrics: undefined
            };
        case territoriesConstants.GET_TERRITORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                metrics: action.metrics
            };
        case territoriesConstants.GET_TERRITORIES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case territoriesConstants.DELETE_TERRITORIES_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case territoriesConstants.DELETE_TERRITORIES_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case territoriesConstants.DELETE_TERRITORIES_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state
    }
} 